const STORAGE_KEY = "app_token";

let token = window.localStorage.getItem(STORAGE_KEY);

export const getToken = () => token;

export const setToken = (newToken: string) => {
    token = newToken;
    window.localStorage.setItem(STORAGE_KEY, newToken);
};

export const removeToken = () => {
    token = null;
    window.localStorage.removeItem(STORAGE_KEY);
};
